<script setup lang="ts">
import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import ImageResponsive from "@/components/ImageResponsive.vue";

defineProps({
  imageSrc: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  buttonLabel: {
    type: String,
    required: true
  },
  buttonDisabled: {
    type: Boolean,
    default: false
  },
  linkTo: {
    type: Object,
    default: () => ({})
  }
});

const emit = defineEmits(["buttonClick"]);

const emitClick = () => {
  emit("buttonClick");
};
</script>

<template>
  <div class="feature-card">
    <div class="feature-card__header">
      <ImageResponsive :src="imageSrc" presentational />
    </div>
    <div class="feature-card__body">
      <p class="feature-card__title">{{ title }}</p>
      <div>
        <TgButton
          :disabled="buttonDisabled"
          full-width
          :tag="buttonDisabled ? 'button' : 'router-link'"
          :to="linkTo"
          @click="emitClick()"
        >
          {{ buttonLabel }}
        </TgButton>
      </div>
    </div>
  </div>
</template>
